<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" >
		<v-card height="90vh" max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-container>
                <v-row>
                    <v-col cols="12">
                    <v-text-field label="Nome" v-model="novoIniciado.nome" outlined></v-text-field> 
                    </v-col>
                    <v-col cols="12">
                    <v-text-field label="E-mail" v-model="novoIniciado.email" outlined></v-text-field> 
                    </v-col>
                    <v-col cols="6">
                        <v-select item-text="nome" item-value="id" :items="this.listaClas" v-model="cla" label="Clã" outlined></v-select>
                    </v-col>
                    <v-col cols="6">
                        <v-menu ref="abrirDtIniciacaoPicker" v-model="abrirDtIniciacaoPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field label="Data da Iniciação" v-model="dataIniciacaoFormatada" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="dataIniciacao" no-title @input="abrirDtIniciacaoPicker = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field type="password" label="Senha" v-model="novoIniciado.senha" outlined></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field type="password" label="Confirmar Senha" v-model="novoIniciado.confirmarSenha" outlined></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

import { mapState } from 'vuex'
import Br from '@/config/barramento.js'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'

export default {
    props: ['propCla'],
    computed:{
			... mapState(['user','iniciado', 'listaClas']),
		},
    data(){
        return{
            abrirDtNascimentoPicker: false,
            abrirDtIniciacaoPicker: false,
            novoIniciado: {},
            mostrar: this.dialog,
            cor: this.$store.state.corEvento,
            dataIniciacao: '',
            dataIniciacaoFormatada: '',
            cla: this.propCla,
        }
    },

    methods:{
        formataDateBr (dt) {
				if (!dt){
					return null
				} 
				const [year, month, day] = dt.split('-')
				const dataTxt = `${day}/${month}/${year}`
				return dataTxt
            },
        
        converterData(dt){
				let data = new Date(dt)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				return data
            },
        
        salvar(){
            this.novoIniciado.cla = this.cla
            
            if(!this.novoIniciado.nome || this.novoIniciado.nome == null){
						showError('Necessário informar o nome!')
					}else if(!this.novoIniciado.email || this.novoIniciado.email == null){
						showError('Necessário informar o email!')
					}else if(!this.novoIniciado.dataIniciacao || this.novoIniciado.dataIniciacao == null){
						showError('Necessário informar a data de iniciação')
					}else if(!this.novoIniciado.senha || this.novoIniciado.senha == null){
						showError('Necessário informar a senha!')
					}else if(!this.novoIniciado.confirmarSenha || this.novoIniciado.confirmarSenha == null){
						showError('Necessário confirmar a senha!')
					}else if(this.novoIniciado.senha !== this.novoIniciado.confirmarSenha){
						showError('Senhas não conferem!')
					}else{

						const url = `${baseApiUrl}/iniciados/iniciado/insert.php`
						const urlEmail = `${baseApiUrl}/emails/novoIniciado.php`
						
						axios.post(url, this.novoIniciado)
							.then(res => {
								console.log('salvar iniciado', res)
								if(res.data.codigo == '01'){
							
									showSuccess(res.data.mensagem)
									axios.post(urlEmail, {email: this.novoIniciado.email, nome: this.novoIniciado.nome, senha: this.novoIniciado.senha})
									
						
								}else if(res.data.codigo == '03'){
									showError(res.data.mensagem)
								}else{
									showError(res.data.mensagem)
									this.$router.push({name: 'iniciados'})
								}
								
							
							
						})

					}
        },

        fechar(){
            this.mostrar = false
        }
    },

    created(){
        Br.onAbrirNovoIniciado(abrir => {
            this.mostrar = true
        })
    },

    watch:{
        dataIniciacao(val){
				this.dataIniciacaoFormatada = this.formataDateBr(this.dataIniciacao)
				this.novoIniciado.dataIniciacao = this.converterData(this.dataIniciacao)
        },
    }
}
</script>

<style scoped>

</style>